module.exports = __webpack_public_path__ + "img/off-close.995a387d.svg";